import * as QRCode from 'qrcode';

export const QR_CODE_OPTIONS = {
  width: 256,
  margin: 2,
  errorCorrectionLevel: 'M' as const,
};

export async function generateQrDataUrl(url: string): Promise<string> {
  return QRCode.toDataURL(url, QR_CODE_OPTIONS);
}

function dataUrlToBlob(dataUrl: string): Blob {
  const [header, base64] = dataUrl.split(',');
  const mimeMatch = header.match(/:(.*?);/);
  const mime = mimeMatch?.[1] ?? 'image/png';
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return new Blob([bytes], { type: mime });
}

export async function copyQrImageToClipboard(dataUrl: string): Promise<void> {
  const blob = dataUrlToBlob(dataUrl);
  if (!navigator.clipboard?.write) {
    throw new Error('Clipboard API not supported');
  }

  await navigator.clipboard.write([
    new ClipboardItem({ [blob.type]: blob }),
  ]);
}
